<template>
  <b-row>
    <b-col cols="12" md="12" lg="6">
      <div
        :key="$store.getters['resource/currentResource'].key"
        class="white-container" style="min-height: 200px">

        <loader v-if="loading"/>

        <!--    <b-form-->
    <!--      v-else-->
    <!--      novalidate-->
    <!--      ref="form"-->
    <!--      @submit.prevent="debounceSubmit"-->
    <!--      :validated="formValidated">-->
    <!--      <PartnerView-->
    <!--        v-if="fields"-->
    <!--        :fields="fields.partner.items"-->
    <!--        :submit="emitSubmitPartnerForm"-->
    <!--        :columnWith="6"-->
    <!--        :editing="true"-->
    <!--        :prefillParams="prefillParams"-->
    <!--        @submit="editPartner"-->
    <!--      />-->
    <!--      <form-buttons></form-buttons>-->
    <!--    </b-form>-->

        <b-row v-else>
          <b-col>
            <h5 class="mb-4">{{ $t('partners.partners_settings') }}</h5>

            <form-fields
                @submit="editPartner"
                :formColumns="12"
                class="px-2"
                :fields="fields"
                :labelBlockWith="4"
                :prefill-params="prefillParams"
                :inline="true"
                :mb="4"
            />
          </b-col>
        </b-row>

      </div>

      <PartnerOwnerEditForm :partner-id="this.id" />
    </b-col>
    <b-col cols="12" md="12" lg="6" >
      <div class="white-container">
        <loader v-if="loadingResources"/>
        <h5>{{ $t('partners.partners_resources') }}</h5>
        <b-button class="my-2" variant="secondary" :to="{path:`${this.id}/create-partner-resource`}">
          {{ $t('partners.add_new_resource') }}
        </b-button>
        <v-client-table
            v-if="prefillParams && prefillParams.resources && !loadingResources"
            :data="prefillParams.resources"
            :columns="columns"
            :options="options">
          <template slot="actions" slot-scope="props">
            <column-action :show-edit-button="true"
                           :route="getEditRoute(props.row.key)"
                           :deleteUrl="`partners/${id}/resources/${props.row.key}/delete`" @deleteItems="getPartnersResources"/>
          </template>
        </v-client-table>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  import fields from "./../partnersRegistration/partnerRegistrationFields"
  import PartnerView from './PartnerView';
  import FormFields from "../../components/global/formBuilder";
  import PartnerOwnerEditForm from "../../components/partners/forms/PartnerOwnerEditForm";

  export default {
    name: 'PartnerEditing',
    middleware: ['auth'],
    components: {
      FormFields,
      PartnerView,
      PartnerOwnerEditForm
    },
    computed: {
      id() {
        return this.$route.params.id || ''
      }
    },
    data() {
      return {
        loading: false,
        loadingResources: false,
        fields: fields.edit.items,
        formValidated: false,
        emitSubmitPartnerForm: false,
        prefillParams: null,
        columns: ['id', 'host', "title", "created_at", "actions"],
        options: {
          skin: 'table-p-1',
          headings: {
            id: '#',
            actions: "",
          },
          filterable: false
        }
      }
    },
    mounted() {
      if (!this.id) {
        this.$router.push({path: '/partners'})
      } else {
        this.getPrefillData();
      }
    },
    methods: {
      async getPrefillData() {
        this.loading = true;
        this.loadingResources = true
        await this.getData(`partners/${this.id}`, null, true)
            .then(({data}) => {
              this.prefillParams = data;
              this.prefillParams.resources_limit = data.settings.resources_limit.toString();
            })
        this.loading = false
        this.loadingResources = false
      },
      async getPartnersResources () {
        this.loadingResources = true;
        await this.getData(`partners/${this.id}`, null, true)
            .then(({data}) => {
              this.prefillParams.resources = data.resources
            })
        this.loadingResources = false
      },
      editPartner (params) {
        this.putData(`partners/${this.id}`, params)
      },
      getEditRoute (resourceKey) {
        return {path:`${this.id}/edit-partner-resource/${resourceKey}`}
      }
    }
  }
</script>
